
import React from 'react';
import { Calendar } from 'lucide-react';
import { DayOfWeek } from '../types';

interface DaySelectorProps {
  days: DayOfWeek[];
  scheduleId: string;
  onDayToggle: (scheduleId: string, day: DayOfWeek) => void;
}

const daysOfWeek: { label: string; value: DayOfWeek }[] = [
  { label: 'Mon', value: 'monday' },
  { label: 'Tue', value: 'tuesday' },
  { label: 'Wed', value: 'wednesday' },
  { label: 'Thu', value: 'thursday' },
  { label: 'Fri', value: 'friday' },
  { label: 'Sat', value: 'saturday' },
  { label: 'Sun', value: 'sunday' },
];

const DaySelector: React.FC<DaySelectorProps> = ({ days, scheduleId, onDayToggle }) => {
  return (
    <div>
      <label className="text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 block">
        <Calendar className="h-4 w-4 inline mr-1" />
        Days
      </label>
      <div className="flex flex-wrap gap-2">
        {daysOfWeek.map(day => (
          <label
            key={day.value}
            className={`
              px-2.5 py-1 rounded-md text-xs font-medium cursor-pointer
              ${days.includes(day.value) 
                ? 'bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-100' 
                : 'bg-gray-100 text-gray-600 dark:bg-gray-800 dark:text-gray-400'}
            `}
            onClick={() => onDayToggle(scheduleId, day.value)}
          >
            {day.label}
          </label>
        ))}
      </div>
    </div>
  );
};

export default DaySelector;
